import { Breadcrumb, ConfigProvider, Typography } from 'antd'
import useTranslation from '@/hooks/useTranslation'
import T from '@/components/common/T'

const { Title, Paragraph } = Typography;

function CityProclamationsPage() {
    const { t } = useTranslation();

    return (
        <main>
            <section
                style={{
                    height: 200,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    flexDirection: "column",
                    backgroundColor: "#d5e8eb",
                    borderRadius: 8,
                    paddingBlock: 25,
                    paddingInline: 50,
                }}
            >
                <Title
                    level={2}
                    style={{
                        textTransform: "uppercase",
                        color: "#2e2525",
                        fontWeight: 600,
                        fontSize: 40,
                        marginBottom: 4,
                    }}
                >
                    <T k="city_proc.title" />
                </Title>
                <Breadcrumb
                    separator=">"
                    style={{ fontSize: 20, fontWeight: 500 }}
                    items={[
                        { title: t("city_proc.breadcrumb.home") },
                        { title: t("city_proc.breadcrumb.title") },
                    ]}
                />
            </section>

            <section style={{ padding: "40px 50px" }}>
                <ConfigProvider
                    theme={{
                        token: {
                            fontSize: 16,
                            lineHeight: "1.2"
                        }
                    }}
                >
                    <Paragraph><T k="city_proc.p1" /></Paragraph>
                    <Paragraph><T k="city_proc.p2" /></Paragraph>
                    <Paragraph><T k="city_proc.p3" /></Paragraph>
                    <Paragraph style={{ marginBottom: 0 }}><T k="city_proc.p4" /></Paragraph>
                    <Paragraph style={{ marginBottom: 0 }}><T k="city_proc.p5" /></Paragraph>
                    <Paragraph style={{ marginBottom: 0 }}><T k="city_proc.p6" /></Paragraph>
                    <Paragraph><T k="city_proc.p7" /></Paragraph>
                    <Paragraph style={{ marginBottom: 0 }}><T k="city_proc.p8" /></Paragraph>
                    <Paragraph><T k="city_proc.p9" /></Paragraph>
                </ConfigProvider>
            </section>
        </main>
    )
}

export default CityProclamationsPage
